import { render, staticRenderFns } from "./InvoiceTax.vue?vue&type=template&id=65b4c333"
import script from "./InvoiceTax.vue?vue&type=script&lang=js"
export * from "./InvoiceTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports